// @dynamic-i18n-keys
// Dynamic t() at lines 33–34, 41–42 (subscriptionSettings × accessSettings; accessSettings from tier.settings):
//   widgets.tierContent.divider.title.subscribed.future_only
//   widgets.tierContent.divider.title.subscribed.all
//   widgets.tierContent.divider.title.subscribed.past_only
//   widgets.tierContent.divider.title.unsubscribed.future_only
//   widgets.tierContent.divider.title.unsubscribed.all
//   widgets.tierContent.divider.title.unsubscribed.past_only
//   widgets.tierContent.divider.subtitle.subscribed.future_only
//   widgets.tierContent.divider.subtitle.subscribed.all
//   widgets.tierContent.divider.subtitle.subscribed.past_only
//   widgets.tierContent.divider.subtitle.unsubscribed.future_only
//   widgets.tierContent.divider.subtitle.unsubscribed.all
//   widgets.tierContent.divider.subtitle.unsubscribed.past_only
import type { FC } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';

import s from './TierContentDivider.scss';

export interface Props {
  className?: string;
  tier: PapiDeviation;
}

const TierContentDivider: FC<Props> = ({ className, tier: { author = {}, tier = {} } }) => {
  const { t } = useTranslation();
  const { isUserSubscribed = false, settings: { accessSettings = 'future_only' } = {} } = tier;
  const subscriptionSettings = isUserSubscribed ? 'subscribed' : 'unsubscribed';
  return (
    <div className={classnames(s['root'], className)}>
      <PromoBadge badgeType="tier" className={s['icon']} isLocked={true} size={40} />
      <div className={s['title']}>
        {t(`widgets.tierContent.divider.title.${subscriptionSettings}.${accessSettings}`, {
          username: author?.username,
        })}
      </div>
      <div className={s['subtitle']}>
        {t(`widgets.tierContent.divider.subtitle.${subscriptionSettings}.${accessSettings}`, {
          username: author?.username,
        })}
      </div>
    </div>
  );
};
TierContentDivider.displayName = 'TierContentDivider';

export default TierContentDivider;
